import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const appointmentsContainerStyle = css`
  max-height: 250px;
  overflow-y: auto;
`;

export const textStyle = css`
  margin-bottom: ${theme.spacing(1.5)};
`;

export const bannerNotificationStyle = css`
  max-width: 100%;
`;

export const accordionItemStyle = css`
  border: 1px solid ${theme.colors.neutral20};
  border-radius: ${theme.borderRadius.medium};
  overflow: hidden;
  box-shadow: none;
`;

export const accordionHeaderStyle = css`
  &[data-active='true'] {
    background: ${theme.colors.neutral5};
  }
  border-bottom: none;

  .header-container {
    padding: ${theme.spacing(2)};
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const tileHeaderContentStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(2)};
  width: 100%;
`;

export const accordionBodyStyle = (nopaddingForAttachments: boolean) => css`
  padding: ${nopaddingForAttachments ? 0 : 'var(--fabric-space-padding-md)'};
`;

export const noteInputStyle = css`
  width: 100%;
  border: 1px solid var(--fabric-color-neutral-20);
  border-radius: var(--border-radius-medium);
  padding: var(--fabric-space-gap-xs);
  resize: none;
  margin-top: var(--fabric-space-gap-md);
`;

export const noteTitleStyle = css`
  max-width: 50%;
  min-width: 280px;
`;

export const titleStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  width: 100%;
`;

export const titleWithBadgeWrapperStyle = css`
  display: flex;
  align-items: center;
  gap: var(--fabric-space-gap-sm);
`;

export const titleTextStyle = css`
  font-size: var(--fabric-font-size-lg);
  line-height: 1.3;
  text-align: left;
`;

export const stepStyle = css`
  display: flex;
  flex-direction: column;
  gap: var(--fabric-space-gap-md);
`;
